export default {
  // list
  'base_cargo_type.query.cargoTypeName': 'cargoTypeName',
  'base_cargo_type.query.cargoTypeName.placeholder': 'Enter cargoTypeName',
  'base_cargo_type.column.cargoTypeName': 'cargoTypeName',
  'base_cargo_type.column.createBy': 'createBy',
  'base_cargo_type.column.updateBy': 'updateBy',
  'base_cargo_type.column.createTime': 'createTime',
  'base_cargo_type.column.updateTime': 'updateTime',
  'base_cargo_type.column.dataSource': 'dataSource',
  'base_cargo_type.column.remark': 'remark',
  'base_cargo_type.column.status': 'status',
  // edit
  'base_cargo_type.edit.title': 'Edit BaseCargoType',
  'base_cargo_type.add.title': 'Add BaseCargoType',
  'base_cargo_type.edit.success': 'Edit Successful',
  'base_cargo_type.add.success': 'Add Successful',
  'base_cargo_type.form.cargoTypeName.required': 'cargoTypeName cannot be null',
  'base_cargo_type.form.cargoTypeName': 'cargoTypeName',
  'base_cargo_type.form.cargoTypeName.placeholder': 'Enter cargoTypeName',
}
